$(document).ready(function(){

  $("input").change(function(){

    //    var pot, cbet = 0;

    if ($.isNumeric($("#equity").val())){
      var equity = parseFloat($("#equity").val());
      $("span#span_equity").text(equity);
    }
    else {
      $("#equity").val("Enter a number");
    };

    if ($.isNumeric($("#pot_before_action").val())){
      var pot = parseFloat($("#pot_before_action").val());
      $("#pot_before_action").text(pot);
    }
    else {
      $("#pot_before_action").val("Enter a number!");
    };

    if ($.isNumeric($("#villain_cbet").val())){
      var vil_cbet = parseFloat($("#villain_cbet").val());
      $("#villain_cbet").text(vil_cbet);
    }
    else {
      $("#villain_cbet").val("Enter a number!");
    };




    $("span#span_amount_win").text(winAmount(equity, pot, vil_cbet));
    $("span#span_amount_lose").text(vil_cbet);
    $("span#span_ev").text(calcEV(equity, pot, vil_cbet));
    setClass(ev);
    $("span#span_reverse_eq").text(losePCT(equity));



  });

  function setClass(ev) {
    if(ev > 0){
      $("span#span_ev").removeClass("math-red");
      $("span#span_ev").addClass("math-green");
    }
    else{
      $("span#span_ev").removeClass("math-green");
      $("span#span_ev").addClass("math-red");
    };
  };

  function losePCT(equity) {
    return 100 - equity;
  };

  function winAmount(equity, pot, vil_cbet) {
    return ((equity/100) * (pot + vil_cbet)).toFixed(2);
  };

  function calcEV(equity, pot, vil_cbet){
    win_amount = winAmount(equity, pot, vil_cbet);
    lose_amount = vil_cbet;
    ev = (win_amount - lose_amount);

    return ev.toFixed(2);
  };




});
